import { Directive, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AccountLogic } from '@mwe/services';

@Directive({ selector: '[mweShowOnlyForImpersonate]' })
export class ShowOnlyForImpersonateDirective implements OnInit {
  private template = inject<TemplateRef<any>>(TemplateRef);
  private container = inject(ViewContainerRef);
  private accountLogic = inject(AccountLogic);

  ngOnInit(): void {
    if (this.accountLogic.isLoggedIn() && this.accountLogic.isImpersonate()) {
      this.container.createEmbeddedView(this.template);
    }
  }
}
